import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";
const API_URL = `${BASE_URL}/api`;

const api = axios.create({
    baseURL: API_URL,
    headers: { "Content-Type": "application/json" }
});

export const projectsAPI = {
    getAll: async (featuredOnly = false) => {
        const params = featuredOnly ? { featured_only: true } : {};
        const { data } = await api.get("/projects", { params });
        return data;
    },

    getById: async (id) => {
        const { data } = await api.get(`/projects/${id}`);
        return data;
    },

    getBySlug: async (slug) => {
        const { data } = await api.get(`/projects/slug/${slug}`);
        return data;
    }
};

export const uploadsAPI = {
    getUrl: (path) => path?.startsWith("http") ? path : `${BASE_URL}${path}`
};

export const skillsAPI = {
    getAll: async () => {
        const { data } = await api.get("/skills");
        return data;
    }
};

export const staticProjectsAPI = {
    getAll: async () => {
        const { data } = await api.get("/static-projects");
        return data;
    },
    getBySlug: async (slug) => {
        const { data } = await api.get(`/static-projects/${slug}`);
        return data;
    }
};

export { api, API_URL, BASE_URL };
